// extracted by mini-css-extract-plugin
module.exports = {"Legends":"Legends_Legends__1McQ9","FiveLegendsGroup":"Legends_FiveLegendsGroup__4CrJz","LegendDiv":"Legends_LegendDiv__1D6Rl"};